var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shitang12"},[_c('el-card',{staticStyle:{"border":"solid #ccc 1px"}},[_c('el-table',{attrs:{"data":_vm.tableData,"stripe":"","border":""}},[_c('el-table-column',{attrs:{"prop":"create_time","label":"时间"}}),_c('el-table-column',{attrs:{"prop":"message","label":"留言"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }